// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleShareBox_title__3QK_f"};